export const FILE_PURPOSE = {
  SS: 0,
  AUTH_SERVER: 1,
  CONNECT: 2,
  PRIVATE: 3,
  BUSINESS_PROCESS_FORM_ICON: 4,
  SS_PRIVATE: 5,
};
